import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * Показывает «Загрузка… Nс», где N — секунды с момента монтирования.
 * Монтируется только при `loading=true` (от родителя), поэтому внутри
 * нет ни синхронного setState в effect body, ни Date.now() в рендере.
 *
 * `minSeconds` по умолчанию 3с: короткие фоновые refetch (после
 * window-focus / realtime-инвалидаций) не должны мигать баннером
 * над уже отрисованной таблицей. Если запрос реально завис —
 * баннер всё равно появится после порога.
 */
export function LoadingSecondsBanner({ minSeconds = 3 }: { minSeconds?: number }) {
  const { t } = useTranslation()
  const [seconds, setSeconds] = useState(0)

  useEffect(() => {
    const start = Date.now()
    const t = setInterval(() => {
      setSeconds(Math.floor((Date.now() - start) / 1000))
    }, 250)
    return () => clearInterval(t)
  }, [])

  if (seconds < minSeconds) return null

  return (
    <div
      role="status"
      aria-live="polite"
      className="flex items-center gap-2 border-b border-[color:var(--stryzh-color-border-default)] px-3 py-2 text-sm text-[var(--stryzh-color-text-secondary)]"
    >
      <span
        aria-hidden="true"
        className="inline-block h-3.5 w-3.5 animate-spin rounded-full border-2 border-[var(--stryzh-color-border-default)] border-t-[var(--stryzh-color-accent-orange)]"
      />
      <span>
        {t('common.loading')} {seconds}{t('common.secondsShort')}
      </span>
    </div>
  )
}
